import { DrawerAndPopover } from "@/shared/components/common/DrawerAndPopover";
import { NestedAction, NestedContentNavigator } from "@/shared/components/ui/NestedContentNavigator";

interface NoteActionsProps {
  actions: () => NestedAction[];
  triggerProps?: { isDisabled?: boolean };
}

export function NoteActions({ actions, triggerProps }: NoteActionsProps) {
  return (
    <DrawerAndPopover id="note-actions" triggerProps={triggerProps}>
      <NestedContentNavigator classNames={{ content: "max-h-64" }} actions={actions()} />
    </DrawerAndPopover>
  );
}
